import {Injectable} from '@angular/core';
import {ApiService} from '@cas-hub/acabim-common-client';
import {Observable} from 'rxjs';
import {CurrentResourceUsage, SubscriptionResourceType} from '../_models/resource-subscription.model';

@Injectable({
    providedIn: 'root'
})
export class ResourceSubscriptionService extends ApiService {

    protected controller = 'ResourceSubscriptions';

    public getCurrentUsage(organisationId: string): Observable<CurrentResourceUsage[]> {
        return this.simpleGet(organisationId);
    }

    public addOrRemoveUsageQuantity(organisationId: string, resourceType: SubscriptionResourceType, changedSeats: number): Observable<any> {
        return this.client.post(this.url(organisationId), {resourceType, changedSeats}, {
            headers: this.defaultHeaders,
            responseType: 'json'
        });
    }
}
